<template>
    <div>
        <Backer />
        <div class="fm-container">
            <div v-if="Object.keys(product_data).length > 0">
                <Product :viewdata="product_data" />
            </div>
        </div>
    </div>
</template>

<script>
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"
    import Product from "@/components/importables/Product"
    export default {
        name: "ViewProduct",
        components: {Backer, Product},
        data: function(){
            return {
                type: null,
                value: null,
                product_data: {}
            }
        },
        methods: {
            get_data: function(){
                let that = this;
                let path = "/api/product/get_product/";
                let params = {type: this.type, value: this.value};
                let s = function(response){
                    if (response.data){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"danger"}
                            );
                        }
                        else {
                            that.product_data = response.data.result;
                        }
                    }
                }

                let f = function(error){
                    console.log("error occurred", error);
                }

                Requestor.getSyncP(path, params, that, s, f);
            }
        },
        created: function(){
            this.type = this.$route.query.type;
            this.value = this.$route.query.value;
            this.get_data();
        },
        
    }
</script>


// WEBPACK FOOTER //
// src/components/ViewProduct.vue